export default {
  data: {
    appName: 'CRMAV100',
    info: {
      visible: false,
      text: ''
    }
  }
}
